import LoadingOverlay from "../../components/LoadingOverlay";

export default function ProfilingResult({ answer, error, loading, onCopy }) {
  return (
    <div className="profilingResult mrt30">
      <div className="answer">
        {loading ? (
          <LoadingOverlay visible={loading} />
        ) : error ? (
          <p className="error">{error}</p>
        ) : answer ? (
          <div><div dangerouslySetInnerHTML={{ __html: answer }} /></div>
        ) : (
          <p>문진 데이터를 붙여넣고 “프로파일링 생성하기”를 눌러 주세요.</p>
        )}
      </div>
    </div>
  );
}
